// Fix change
if (BSS_B2B) {
    window.addEventListener("cart_changed", () => {
        setTimeout(() => {
            let storeData = JSON.parse($("#bss-b2b-store-data").html());
            BSS_B2B.makeChangesAfterClickAjaxCart(500)
            BSS_B2B.cart.fixer(storeData, null, false);
            BSS_B2B.handleCartCheckoutBtn(storeData);
            BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false)
        }, 500);
    });

    // fix spam checkout
    setTimeout(() => {
        function handleButtonClick(e) {
            e.preventDefault();
            const $button = $(this);
            let oldText = $(this).text();
            $button.css({'pointer-events': 'none', 'opacity': '0.6'});
            $button.text("Loading ...");
            setTimeout(() => {
                $button.css({'pointer-events': 'unset', 'opacity': '1'})
                $button.text(oldText);
            }, 2000);
        }
        $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
    }, 500)
    BSS_B2B.customTriggerCheckoutBtn = function (checkoutBtn) {
        window.location.href = "/checkout";
    }
}


const selector = ".bss-b2b-vat-input";
let counter = 0;

const interval = setInterval(() => {
    const vatInput = document.querySelector(selector);
    if (vatInput) {
        if (window.vatNumber) {
            vatInput.value = window.vatNumber;
            vatInput.setAttribute("readonly", true);
        }
        clearInterval(interval);
    } else if ((counter += 100) >= 10000) {
        clearInterval(interval); 
    }
}, 100);


